export enum Status {
  DRAFT = 'Draft',
  OPEN = 'Open',
  VOID = 'Void',
  PAID = 'Paid',
  UNCOLLECTIBLE = 'Uncollectible'
}
